import { render, staticRenderFns } from "./BrandEnd.vue?vue&type=template&id=b23eb9ec&scoped=true&"
import script from "./BrandEnd.vue?vue&type=script&lang=js&"
export * from "./BrandEnd.vue?vue&type=script&lang=js&"
import style0 from "./BrandEnd.vue?vue&type=style&index=0&id=b23eb9ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23eb9ec",
  null
  
)

export default component.exports